<div class="flex align-center pad-bot-20 pad-top-10 back-contain {{bgColor}}" [ngStyle]="{'background-color': bgColor}">
    <div class="f700 accenttwo  pointer relative back-in w100 flex align-center" (click)="back()">
        <svg class="back-arrow  " width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 15L1 8L8 1" stroke="#E7503D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span class="pad-left-15 flex align-center fnt-20 f700">{{text}}</span>
    </div>
</div>